module.exports = __webpack_public_path__ + "img/Weapon_143.26d6ca95.png";